import MVideo from './MVideo';

export default MVideo;
